import i18n from "@/i18n";

/* eslint-disable @typescript-eslint/camelcase */
export const REQUEST_TYPE_CLIENT_RATE_HISTORY = {
  registration: "Pembuatan Klien Baru",
  add_rate: "Harga Baru",
  update_rate: "Ubah Harga",
  change_rate: "Ubah Harga",
  update_insurance: "Ubah Asuransi",
  change_insurance: "Ubah Asuransi",
  update_period: "Ubah Periode",
  change_period: "Ubah Periode",
};

/* eslint-disable @typescript-eslint/camelcase */
export const PRICE_TYPE_CLIENT_RATE_HISTORY = {
  retail: "Harga Retail",
  normal: "Harga Normal",
  normal_custom_3lc: "Harga Normal Custom 3LC",
  custom_client: "Harga Khusus Klien",
  custom_client_retail_district: "Harga Khusus Klien Retail Distrik",
  combination: "Harga Kombinasi",
  combination_custom_3lc: "Harga Kombinasi Custom 3LC"
};

export const STATUS_CLIENT_RATE_HISTORY = {
  waiting: {
    label: String((i18n as any).global.t("clientManagement.clientRateHistory.waiting")),
    color: "gray"
  },
  requested: {
    label: String((i18n as any).global.t("clientManagement.clientRateHistory.requested")),
    color: "yellow"
  },
  rejected: {
    label: String((i18n as any).global.t("clientManagement.clientRateHistory.rejected")),
    color: "red"
  },
  cancelled: {
    label: String((i18n as any).global.t("clientManagement.clientRateHistory.cancelled")),
    color: "red"
  },
  "rejected-partial": {
    label: String((i18n as any).global.t("clientManagement.clientRateHistory.rejectedPartial")),
    color: "red"
  },
  active: {
    label: String((i18n as any).global.t("clientManagement.clientRateHistory.active")),
    color: "green"
  },
  approved: {
    label: String((i18n as any).global.t("clientManagement.clientRateHistory.approved")),
    color: "green"
  },
  "approved-partial": {
    label: String((i18n as any).global.t("clientManagement.clientRateHistory.approvedPartial")),
    color: "green"
  },
  nearly_expired: {
    label: String((i18n as any).global.t("clientManagement.clientRateHistory.nearlyExpired")),
    color: "yellow"
  },
  expired: {
    label: String((i18n as any).global.t("clientManagement.clientRateHistory.expired")),
    color: "gray"
  },
  pending: {
    label: String((i18n as any).global.t("clientManagement.clientRateHistory.pending")),
    color: "yellow"
  },
  uploading: {
    label: String((i18n as any).global.t("clientManagement.clientRateHistory.uploading")),
    color: "blue"
  }
} as const;
